import React from 'react';

const savedIcon = () => (
    <svg viewBox="0 0 37.732 60">
        <path d="M35.358,0H2.372C1.062,0,0,1.063,0,2.374v55.255C0,58.939,1.062,60,2.372,60l16.494-13.685
		L35.358,60c1.313,0,2.374-1.061,2.374-2.371V2.374C37.732,1.063,36.671,0,35.358,0z"/>
    </svg>
)

export default savedIcon;